import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-setupintegrations',
  templateUrl: './setupintegrations.component.html',
  styleUrls: ['./setupintegrations.component.css']
})
export class SetupintegrationsComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  displayNext() {
    this.router.navigate(['/dashboard']);
  }
}
